import React from 'react';
import ReactDOM from 'react-dom';
import { Header as SalesHeader, Footer } from '@ux/sales-header';
import ProductNav from '@ux/product-nav';

function Header(props) {
  return <SalesHeader ProductNav={ ProductNav } { ...props } />
}

//
// Copy down {propTypes,defaultProps} for a proper
// pass through functional component.
//
Header.propTypes = SalesHeader.propTypes;
Header.defaultProps = SalesHeader.defaultProps;

export {
  Header,
  Footer
};
